module.exports = __webpack_public_path__ + "media/lifesum-intro-en-fef65c30.mp4";